var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFmpBrainOriginal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 410.91 345.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3e6ab2;}.cls-2{fill:#58a1d7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 278.28,
    cy: 185.7,
    r: 29.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 119.2,
    cy: 24.64,
    r: 19.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.9,
    cy: 70.82,
    r: 19.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 204.05,
    cy: 139.99,
    r: 19.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 151.98,
    cy: 242.23,
    r: 19.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100.06,
    cy: 266.95,
    r: 19.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 62.77,
    cy: 186.31,
    r: 19.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.54,
    cy: 97.09,
    r: 19.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 14.15,
    cy: 219.43,
    r: 12.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 62.58,
    cy: 237.56,
    r: 12.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.8,
    cy: 242.9,
    r: 11.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 224.81,
    cy: 12.02,
    r: 12.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 171.38,
    cy: 14.36,
    r: 12.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 206.62,
    cy: 269.86,
    r: 12.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.96,
    y: 174.21,
    width: 7.56,
    height: 58.3,
    transform: "translate(184.56 57.67) rotate(55.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 58.89,
    y: 186.85,
    width: 7.56,
    height: 50.96,
    transform: "translate(0.8 -0.23) rotate(0.22)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 77.63,
    y: 228.81,
    width: 7.56,
    height: 47.04,
    transform: "translate(-167.38 160.67) rotate(-51.89)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 175.57,
    y: 225.16,
    width: 7.56,
    height: 61.82,
    transform: "translate(488.81 211.62) rotate(116.83)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 240.36,
    y: 126.42,
    width: 7.14,
    height: 79.01,
    transform: "translate(509.27 36.97) rotate(119.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 238.39,
    y: 46.93,
    width: 7.56,
    height: 73.41,
    transform: "translate(406.71 -112.77) rotate(110.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 212.76,
    y: 9.4,
    width: 7.56,
    height: 62.7,
    transform: "translate(19.7 -58.27) rotate(16.05)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 195.18,
    y: -14.42,
    width: 7.56,
    height: 52.88,
    transform: "translate(194.14 -187.25) rotate(85.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 141.76,
    y: -8.23,
    width: 7.56,
    height: 54.71,
    transform: "translate(139.33 -127.54) rotate(80.09)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 263.8,
    y: 184.25,
    width: 7.14,
    height: 60.5,
    transform: "translate(443.14 508.78) rotate(-159.59)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 133.64,
    cy: 164.21,
    r: 31.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 343.84,
    cy: 60.59,
    r: 31.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 63.24,
    cy: 63.28,
    r: 19.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 275.61,
    cy: 31.64,
    r: 19.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 391.59,
    cy: 163.34,
    r: 19.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 64.47,
    cy: 130.66,
    r: 19.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 12.02,
    cy: 106.92,
    r: 12.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 12.02,
    cy: 163.34,
    r: 12.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 340.07,
    cy: 191.33,
    r: 12.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 394.54,
    cy: 104.98,
    r: 12.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 340.91,
    cy: 130.68,
    r: 12.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 200.04,
    cy: 207.41,
    r: 12.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 154.97,
    cy: 298.1,
    r: 11.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 107.68,
    cy: 333.26,
    r: 12.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 135.97,
    cy: 87.65,
    r: 19.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 338.53,
    y: 60.62,
    width: 7.56,
    height: 70.07,
    transform: "translate(4.11 -13.64) rotate(2.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 305.75,
    y: 8.68,
    width: 7.56,
    height: 74.59,
    transform: "translate(472.35 -221.26) rotate(112.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 364.16,
    y: 87.74,
    width: 7.56,
    height: 59.97,
    transform: "translate(315.15 -264.96) rotate(64.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 389.27,
    y: 105.1,
    width: 7.56,
    height: 58.53,
    transform: "translate(7.3 -19.72) rotate(2.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 362.34,
    y: 148.39,
    width: 7.56,
    height: 57.57,
    transform: "translate(347.04 -229.11) rotate(61.49)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 164.52,
    y: 145.48,
    width: 7.56,
    height: 82.85,
    transform: "translate(416.63 147.01) rotate(122.88)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 95.38,
    y: 36.81,
    width: 7.56,
    height: 77.01,
    transform: "translate(202.09 5.23) rotate(108.53)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 59.79,
    y: 63.23,
    width: 7.56,
    height: 67.5,
    transform: "translate(-2.55 1.72) rotate(-1.52)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.24,
    y: 105.31,
    width: 7.56,
    height: 58.3,
    transform: "translate(0.26 -0.02) rotate(0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 34.58,
    y: 88.9,
    width: 7.56,
    height: 58.3,
    transform: "translate(-85.31 107.44) rotate(-67.1)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 127.28,
    y: 286.3,
    width: 7.02,
    height: 59.68,
    transform: "translate(307.03 22.9) rotate(53.48)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFmpBrainOriginal);
export default __webpack_public_path__ + "static/media/fmp-brain-original.c0c720aecbe8ce2f5e958f76bbf109bd.svg";
export { ForwardRef as ReactComponent };